import styled from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
export const Container = styled.header``;
export const Content = styled.div`
  background: ${props => themeGet('palette.background.primary')(props)};
  height: ${props => themeGet('sizes.header')(props)};
  color: #fff;
  padding: 5px 9px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    [id='logo'] {
      margin-top: 5px;
      width: 98px;
      height: 21px;
    }

    [id='button-burger'] {
      width: 22px;
      height: 22px;
    }
  }

  [id='search-container'] {
    margin-bottom: 5px;
  }
`;
/* add this div just to align shoppingbag icon */

export const AlignIcon = styled.div`
  > a {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
export const Link = styled.a`
  text-decoration: none;
`;
export const Search = styled.input`
  width: 100%;
  border: 0px;
  height: 30px;
  background-color: #fff;
  color: #9b9b9b;
  font-size: 16px;
  padding-left: 10px;
  box-sizing: border-box;

  ::-webkit-search-cancel-button {
    background-color: #818181;
    position: relative;
    right: 10px;
  }
`;